export default "__VITE_ASSET__5e908685__"